export const INLINE_PLATFORMS = [
  "desktop",
  "mobile",
  "iOS",
  "android",
] as const;
export type InlinePlatform = (typeof INLINE_PLATFORMS)[number];
export const INLINE_DATE_FORMATS = [
  "dd/mm/aaaa",
  "dd-mm-aaaa",
  "dd/mm/aa",
  "mm/dd/aaaa",
  "aaaa-mm-dd",
] as const;
export type InlineDateFormat = (typeof INLINE_DATE_FORMATS)[number];

export interface InlineBannerData {
  title: string;
  url: string;
  description?: string;
  image?: string;
  image_alt?: string;
  id?: string;
  cta?: string;
}

/** Public JSON contract. Runtime validation is still required. */
export interface InlineCampaignConfig {
  ACTIVE: boolean;
  PLATFORMS: InlinePlatform[];
  ORIGIN_AIRPORTS: string;
  DESTINATION_AIRPORTS: string;
  DATA_TYPE?: InlineDateFormat;
  PARAMETERS: InlineBannerData;
}
export interface InlineConfig {
  ACTIVE: boolean;
  CAMPAIGNS: InlineCampaignConfig[];
}

/** Normalized campaigns never expose arbitrary JSON properties to the UI. */
export interface InlineCampaign {
  index: number;
  active: boolean;
  platforms: InlinePlatform[];
  origins: string[];
  destinations: string[];
  dateFormat: InlineDateFormat;
  parameters: InlineBannerData;
}
export interface InlineIssue {
  index: number;
  error: Error;
}
export interface ParsedInlineConfig {
  campaigns: InlineCampaign[];
  issues: InlineIssue[];
}
export interface InlineSearch {
  originAirport: string;
  destinationAirport: string;
  departureDates: readonly string[] | null;
  returnDates: readonly string[] | null;
  adults: number;
  children: number;
  babies: number;
}
